import React, { useEffect, useLayoutEffect, useState } from 'react';
import './profile.css';
import axios from 'axios';
import {Card, Button, 
    Table, OverlayTrigger, Modal} from 'react-bootstrap';
    import OverLay from './overlay';
const Profile=(props)=>{
    const [profiledata, setprofiledata]=useState(props.userData)
    const [scheme, setscheme]=useState([])
    const [apiCallchangepassword, setapiCallchangepassword]=useState(false)
    const [show_changePasswordModal, setshow_changePasswordModal]=useState({
        modal:false,
        currentPassword:'',
        newpassword:'',
        matchPassword:'',
        err:''
    })
    const [schemename, setschemename]=useState('')
    const fetscallScheme=()=>{
        axios.get('/get_schemes_stamp_paper').then((res)=>{
          
          res.data.data.forEach(key=>{
              if(profiledata.corporate_id===key.id){
                setschemename(key.scheme_name)
              }
          })
          setscheme(res.data.data)
        })
      }
     const change_password=()=>{
         let err={}
         if(show_changePasswordModal.currentPassword===''){
             err['currentPassword']='Please Enter Current Password'
         }
         if(show_changePasswordModal.newpassword===''){
            err['newpassword']='Please Enter New Password'
        }
        if(show_changePasswordModal.matchPassword===''){
            err['matchPassword']='Please Enter Confirm Password'
        }
        if(show_changePasswordModal.newpassword!==''&&show_changePasswordModal.matchPassword!==''){
            if(show_changePasswordModal.newpassword!==show_changePasswordModal.matchPassword){
                err['match']='Password Not Match'
            }
        }
        setshow_changePasswordModal({...show_changePasswordModal, err:err})
        // console.log(Object.keys(err).length,err)
        if(Object.keys(err).length===0){
            setshow_changePasswordModal({...show_changePasswordModal, modal:false})
            setapiCallchangepassword(true)
            axios.post('/change_password_mobile', {
                currentPassword:show_changePasswordModal.currentPassword,
                newpassword:show_changePasswordModal.newpassword,
                matchPassword:show_changePasswordModal.matchPassword,
                user_id:props.userData.id
            }).then((res)=>{
                setapiCallchangepassword(false)
                alert(res.data.message)
                console.log(res.data)
            })
        }
     }
      useEffect(()=>{
          fetscallScheme()
      },[])
    return(
        <div className='ContainerCard2'>
            <form>
                <div className="form-group">
                    <label for="exampleInputEmail1">Name</label>
                    <input 
                        value={profiledata.name}
                        type="text" 
                        className="form-control" 
                        id="exampleInputEmail1" 
                        aria-describedby="emailHelp" placeholder="Enter Name"/>
                        <br/>
                        <br/>
                </div>
                <div className="form-group">
                    <label for="exampleInputEmail1">Email</label>
                    <input 
                        value={profiledata.email}
                        type="email" 
                        className="form-control" 
                        id="exampleInputEmail1" 
                        aria-describedby="emailHelp" placeholder="Enter email"/>
                        <br/>
                </div>
                <div className="form-group">
                    <label for="exampleInputEmail1">Contact Number</label>
                    <input 
                        value={profiledata.phone_number}
                        type="email" 
                        className="form-control" 
                        id="exampleInputEmail1" 
                        aria-describedby="emailHelp" placeholder="Enter Mobile Number"/>
                        <br/>
                </div>
                <div className="form-group">
                    <label for="exampleInputEmail1">Corporate Name</label>
                    <input 
                        value={schemename}
                        type="email" 
                        className="form-control" 
                        id="exampleInputEmail1" 
                        aria-describedby="emailHelp" placeholder="Enter Corporate Name"/>
                </div>
                {/*
                    <button type="submit" className="btn btn-primary">Submit</button>
                */}
            </form>
            <div style={{paddingTop:10}}>
                <button onClick={()=>{
                    setshow_changePasswordModal({...show_changePasswordModal, modal:true})
                }} className="btn btn-primary">Change Password</button>
            </div>
            <Modal show={show_changePasswordModal.modal} onHide={()=>{
                setshow_changePasswordModal({...show_changePasswordModal, modal:false})
            }}>
                <Modal.Header closeButton closeLabel=''>
                <Modal.Title>Change Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            <label>Enter Your Current Password</label>
                        </div>
                        <div>
                            <input type='password'
                            className="form-control"
                            value={show_changePasswordModal.currentPassword}
                            onChange={(ev)=>{
                                 setshow_changePasswordModal({...show_changePasswordModal, currentPassword:ev.target.value})
                            }}/>
                        </div>
                        {(show_changePasswordModal.err['currentPassword'])&&
                            <div>
                                <span style={{color:'red'}}>{show_changePasswordModal.err['currentPassword']}</span>
                            </div>
                        }
                    </div>
                    <div>
                        <div>
                            <label>Enter New Password</label>
                        </div>
                        <div>
                            <input className="form-control" type='password' value={show_changePasswordModal.newpassword}
                            onChange={(ev)=>{
                                setshow_changePasswordModal({...show_changePasswordModal, newpassword:ev.target.value})
                            }}/>
                        </div>
                        {(show_changePasswordModal.err['newpassword'])&&
                            <div>
                                <span style={{color:'red'}}>{show_changePasswordModal.err['newpassword']}</span>
                            </div>
                        }
                    </div>
                    <div>
                        <div>
                            <label>Confirm New Password</label>
                        </div>
                        <div>
                            <input className="form-control" type='password' value={show_changePasswordModal.matchPassword}
                            onChange={(ev)=>{
                                setshow_changePasswordModal({...show_changePasswordModal, matchPassword:ev.target.value})
                            }}/>
                        </div>
                        {(show_changePasswordModal.err['matchPassword']||show_changePasswordModal.err['match'])&&
                            <div>
                                <span style={{color:'red'}}>{show_changePasswordModal.err['match']}</span>
                                <span style={{color:'red'}}>{show_changePasswordModal.err['matchPassword']}</span>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={()=>{
                    setshow_changePasswordModal({...show_changePasswordModal, modal:false})
                }}>
                    Close
                </Button>
                <Button variant="primary" onClick={()=>{
                    change_password()
                }}>
                    Save Changes
                </Button>
                </Modal.Footer>
            </Modal>
            <OverLay active={apiCallchangepassword}/>
        </div>
    )
}
export default Profile;